import React from "react";
import axios from "@/utils/myAxios";
import moment from "moment";
import Cookie from "js-cookie";
import { Link } from "react-router-dom";
import { tableSummaries, isMobileDevice } from "@/utils/utils";
import {
    message,
    Card,
    Switch,
    Button,
    Form,
    InputNumber,
    Modal,
    Spin,
    Statistic,
    Row,
    Table,
    Pagination,
} from "antd";

export default class ActivityBadBeatJackpot extends React.Component {
    state = {
        loading: false, // 是否加载中
        dataInfo: {}, // 数据信息
    };

    componentDidMount () {
        this.fetchDataInfo();
    }

    /**
     * 获取数据
     */
    fetchDataInfo = () => {
        this.setState({ loading: true });
        axios.get("/v1/api/activity_get_bad_beat_jack_pot_conf").then((res) => {
            this.setState({
                loading: false,
                dataInfo: res.data || {},
            });
        });
    };

    /**
     * 更新配置
     */
    handleUpdateConfig = (key, value) => {
        axios
            .patch("/v1/api/activity_set_bad_beat_jack_pot_conf", {
                is_open: this.state.dataInfo.is_open,
                [key]: value,
            })
            .then((res) => {
                if (res.code === 1) {
                    message.success(this.props.language["operationSuccessMessage"]);
                    this.fetchDataInfo();
                }
            });
    };

    /**
     * 充值奖池数量
     */
    handleRechargePool = () => {
        this.formRef.props.form.validateFields((err, values) => {
            if (!err) {
                if (values.recharge_amount > this.state.dataInfo.super_union_point)
                    return message.error(
                        this.props.language["insufficientPointsMessage"]
                    );
                Modal.confirm({
                    title: this.props.language["hint"],
                    content: this.props.getLanguage(
                        "rechargeIntegralConfirm",
                        values.recharge_amount
                    ),
                    onOk: () => {
                        axios
                            .patch("/v1/api/activity_set_bad_beat_jack_pot_conf", {
                                is_open: this.state.dataInfo.is_open,
                                recharge_amount: values.recharge_amount,
                            })
                            .then((res) => {
                                if (res.code === 1) {
                                    message.success(
                                        this.props.language["rechargeSuccessMessage"]
                                    );
                                    this.formRef.props.form.resetFields();
                                    this.fetchDataInfo();
                                }
                            });
                    },
                });
            }
        });
    };

    render () {
        return (
            <Spin spinning={this.state.loading}>
                <div className="p10">
                    {/* 当前奖池 */}
                    <Card
                        title={
                            <h2>
                                {this.props.language["currentPrizePool"]}
                            </h2>
                        }
                        type="inner"
                    >
                        <Row type="flex" align="middle">
                            <div className="number-box-list">
                                <div className="value-list">
                                    <div className="value-item">
                                        <Statistic
                                            value={Number(this.state.dataInfo.bonus_in_pool || 0)}
                                        />
                                        <p className="label">
                                            {this.props.language["currentPrizePool"]}
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </Row>
                    </Card>

                    {/* 充值奖池 */}
                    <Card
                        className="mt20"
                        title={
                            <Row type="flex" align="middle">
                                <h2>
                                    {this.props.language["rechargePrizePool"]}
                                </h2>
                                <h3>
                                    （{this.props.language["counterPoint"]}：
                                    {this.state.dataInfo.super_union_point}）
                                </h3>
                            </Row>
                        }
                        type="inner"
                    >
                        <PoolForm
                            {...this.props}
                            onOk={this.handleRechargePool}
                            dataInfo={this.state.dataInfo}
                            wrappedComponentRef={(formRef) => (this.formRef = formRef)}
                        />
                    </Card>

                    {/* 活动开关 */}
                    <Card
                        className="mt20"
                        title={
                            <h2>{this.props.language["activitySwitch"]}</h2>
                        }
                        type="inner"
                    >
                        <Row type="flex" align="middle" justify="space-between">
                            <h3>{this.props.language["activitySwitch"]}</h3>
                            <Switch
                                checked={this.state.dataInfo && this.state.dataInfo.is_open}
                                onChange={(value) => this.handleUpdateConfig("is_open", value)}
                            />
                        </Row>
                    </Card>

                    {/* 功能说明 */}
                    <Card
                        className="mt20"
                        title={
                            <h2>
                                {this.props.language["functionDescription"]}
                            </h2>
                        }
                        type="inner"
                    >
                        <h3 className='mb5'>{this.props.language["winCondition"]}</h3>
                        <h4>{this.props.language["winCondition1"]}</h4>
                        <h4>{this.props.language["winCondition2"]}</h4>
                        <h4>{this.props.language["winCondition3"]}</h4>
                        <h4>{this.props.language["winCondition4"]}</h4>
                        <h3 className="mt20 mb5">
                            {this.props.language["minHandCard"]}
                        </h3>
                        <h4>{this.props.language["handCardType1"]}</h4>
                        <h4>{this.props.language["handCardType2"]}</h4>
                        <h4>{this.props.language["handCardType3"]}</h4>
                        <h4>{this.props.language["handCardType4"]}</h4>
                        <h3 className="mt20 mb5">
                            {this.props.language["serviceFeeAndBonusRatio"]}
                        </h3>
                        <Table scroll={{ x: true }}
                            rowKey={(record, index) => index} className="mt10" bordered size="small" pagination={false} dataSource={[
                                {
                                    blindBet: '1/2 ~ 2/4',
                                    serviceFee: '0.6BB',
                                    underdog: '8.25%',
                                    winner: '3.75%',
                                    otherPlayer: '3%',
                                    totalPrize: '15%',
                                },
                                {
                                    blindBet: '5/10 ~ 10/20',
                                    serviceFee: '0.4BB',
                                    underdog: '13.75%',
                                    winner: '6.25%',
                                    otherPlayer: '5%',
                                    totalPrize: '25%',
                                },
                                {
                                    blindBet: '25/50 ~ 50/100',
                                    serviceFee: '0.25BB',
                                    underdog: '19.25%',
                                    winner: '8.75%',
                                    otherPlayer: '7%',
                                    totalPrize: '35%',
                                },
                                {
                                    blindBet: '100/200 ~ 200/400',
                                    serviceFee: '0.12BB',
                                    underdog: '27.5%',
                                    winner: '12.5%',
                                    otherPlayer: '10%',
                                    totalPrize: '50%',
                                },
                                {
                                    blindBet: '500/1K - 1K/2K',
                                    serviceFee: '0.06BB',
                                    underdog: '35.75%',
                                    winner: '16.25%',
                                    otherPlayer: '13%',
                                    totalPrize: '65%',
                                },
                                {
                                    blindBet: '2K/4K +',
                                    serviceFee: '0.03BB',
                                    underdog: '44%',
                                    winner: '20%',
                                    otherPlayer: '16%',
                                    totalPrize: '80%',
                                },
                            ]}>
                            <Table.Column align="center" title={this.props.language["blindBet"]} dataIndex="blindBet" />
                            <Table.Column align="center" title={this.props.language["serviceFee"]} dataIndex="serviceFee" />
                            <Table.ColumnGroup title={this.props.language["award"]}>
                                <Table.Column align="center" title={this.props.language["underdog"]} dataIndex="underdog" />
                                <Table.Column align="center" title={this.props.language["winner"]} dataIndex="winner" />
                                <Table.Column align="center" title={this.props.language["otherPlayer"]} dataIndex="otherPlayer" />
                                <Table.Column align="center" title={this.props.language["totalPrize"]} dataIndex="totalPrize" />
                            </Table.ColumnGroup>
                        </Table>
                    </Card>
                </div>
            </Spin>
        );
    }
}

/**
 * 充值奖池表单
 */
const PoolForm = Form.create({ name: "pool_form_box" })(
    class FormBox extends React.Component {
        render () {
            const { getFieldDecorator } = this.props.form;
            return (
                <Form layout="inline">
                    <Form.Item>
                        {getFieldDecorator("recharge_amount", {
                            rules: [
                                {
                                    required: true,
                                    message: this.props.language["rechargeAmountVerify"],
                                },
                            ],
                        })(
                            <InputNumber
                                min={1}
                                max={100000000}
                                precision={0}
                                placeholder={this.props.language["rechargeAmountPlaceholder"]}
                            />
                        )}
                    </Form.Item>
                    <Form.Item>
                        <Button type="primary" onClick={this.props.onOk}>
                            {this.props.language["recharge"]}
                        </Button>
                    </Form.Item>
                </Form>
            );
        }
    }
);
